import axios from "axios";

const LeavePriorService = {
  GetLeavePriorList: (date) =>
    axios.get(`LeavePrior/GetLeavePriorList?date=${date}`),

  GetNotApprovedLeavePriorList: (params) =>
    axios.get("LeavePrior/GetNotApprovedLeavePriorList", { params }),

  UpdateLeavePriorList: (params) =>
    axios.post("LeavePrior/UpdateLeavePriorList", null, { params }),
};

export default LeavePriorService;